(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react-emotion', '@material-ui/core', './Buttons.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react-emotion'), require('@material-ui/core'), require('./Buttons.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.reactEmotion, global.core, global.Buttons);
    global.Buttons = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _reactEmotion, _core, _Buttons) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ButtonFlatSmall = exports.ButtonFlatLarge = exports.ButtonSecondarySmall = exports.ButtonSecondaryLarge = exports.ButtonPrimarySmall = exports.ButtonPrimaryLarge = undefined;

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n']);

  /**
   * Tech Debt (DEV-2204): Redo Buttons with withStyles to reset styles from MUI
   */

  var ButtonPrimaryLarge = exports.ButtonPrimaryLarge = (0, _reactEmotion2.default)(_core.Button)(_templateObject, _Buttons.buttonCoreStyles, _Buttons.buttonLargeStyles, _Buttons.buttonPrimaryStyles);

  var ButtonPrimarySmall = exports.ButtonPrimarySmall = (0, _reactEmotion2.default)(_core.Button)(_templateObject, _Buttons.buttonCoreStyles, _Buttons.buttonSmallStyles, _Buttons.buttonPrimaryStyles);

  var ButtonSecondaryLarge = exports.ButtonSecondaryLarge = (0, _reactEmotion2.default)(_core.Button)(_templateObject, _Buttons.buttonCoreStyles, _Buttons.buttonLargeStyles, _Buttons.buttonSecondaryStyles);

  var ButtonSecondarySmall = exports.ButtonSecondarySmall = (0, _reactEmotion2.default)(_core.Button)(_templateObject, _Buttons.buttonCoreStyles, _Buttons.buttonSmallStyles, _Buttons.buttonSecondaryStyles);

  var ButtonFlatLarge = exports.ButtonFlatLarge = (0, _reactEmotion2.default)(_core.Button)(_templateObject, _Buttons.buttonCoreStyles, _Buttons.buttonLargeStyles, _Buttons.buttonFlatStyles);

  var ButtonFlatSmall = exports.ButtonFlatSmall = (0, _reactEmotion2.default)(_core.Button)(_templateObject, _Buttons.buttonCoreStyles, _Buttons.buttonSmallStyles, _Buttons.buttonFlatStyles);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/Buttons.js
// module id = 1182
// module chunks = 0